import { IPublicUser } from '@sravni/types/lib/auth';

import { IGlobalState } from '../index';

export const getUser = (state: IGlobalState): IPublicUser | null => (state.user.loggedIn ? state.user.account : null);
